import { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { FiSettings, FiTrash2, FiUsers, FiEdit3 } from 'react-icons/fi';
import { useOrgContext } from '../../context/org';
import { useParams } from 'react-router-dom';
import ConfirmDeleteOrg from './ConfirmDeleteOrg';
import BasicSettings from './BasicSettings';
import Members from './Members';

const Settings = () => {
	const [deleteOrg, setDeleteOrg] = useState(false);
	const [error, setError] = useState("");

	const { getOrgById, setOrg, membership } = useOrgContext();
	const { orgId } = useParams();
	const org = getOrgById(orgId || "");

	const allowed = ["owner", "admin", "editor"];
	const permission = !allowed.includes(membership?.role || "");
	
	useEffect(() => { setOrg(org) }, [org, setOrg]);

	return (
		<>
			{org && (
				<div className="settings-page">
					<Container fluid style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem' }}>
						{/* Header Section */}
						<div className="header-section mb-4">
							<div className="d-flex align-items-center mb-2">
								<FiSettings className="me-3 text-primary" size={32} />
								<h1 className="display-6 fw-bold text-light mb-0">Organization Settings</h1>
							</div>
							<p style={{ color: '#ccc' }}>
								Manage your organization details, members, and preferences
							</p>
						</div>

						<Row className="g-4">
							{/* General Settings Card */}
							<div className="settings-section mb-4">
								<div className="d-flex align-items-center mb-3">
									<FiEdit3 className="me-2 text-primary" size={20} />
									<h4 className="text-light mb-0">General Settings</h4>
								</div>
								<BasicSettings org={org} />
							</div>

							{/* Members Management Card */}
							<div className="settings-section mb-4">
								<div className="d-flex align-items-center mb-3">
									<FiUsers className="me-2 text-primary" size={20} />
									<h4 className="text-light mb-0">Team Members</h4>
								</div>
								<Members org={org} />
							</div>
						</Row>
						<Row className="g-4">
							<div className="settings-section">
								<div className="d-flex align-items-center mb-3">
									<FiTrash2 className="me-2 text-danger" size={20} />
									<h4 className="text-light mb-0">Danger Zone</h4>
								</div>
								
								<Card className="border-danger bg-dark">
									<Card.Body>
										<Card.Title className="text-danger d-flex align-items-center">
											<FiTrash2 className="me-2" size={18} />
											Delete Organization
										</Card.Title>
										<Card.Text className="text-light mb-3">
											Once deleted, all uploaded data and trained agents 
											associated with this organization will be permanently removed.
										</Card.Text>
										<Card.Text className="text-danger small fw-bold mb-3">
											⚠️ This action cannot be undone
										</Card.Text>
										
										{error && (
											<Alert 
												variant="danger" 
												className="mb-3"
												style={{ 
													backgroundColor: 'rgba(220, 53, 69, 0.1)', 
													borderColor: '#dc3545',
													color: '#f5c6cb'
												}}
											>
												{error}
											</Alert>
										)}
										
										<Button
											disabled={permission}
											className={`${permission ? 'disabledCursor' : ""} w-100`}
											variant="outline-danger" 
											onClick={() => setDeleteOrg(true)}
										>
											<FiTrash2 className="me-2" size={16} />
											Delete Organization
										</Button>
										
										{permission && (
											<small className="text-muted d-block mt-2 text-center">
												Only owners and admins can delete organizations
											</small>
										)}
									</Card.Body>
								</Card>
							</div>
						</Row>

						{/* Delete Confirmation Modal */}
						{deleteOrg && (
							<ConfirmDeleteOrg 
								org={org} 
								cancel={setDeleteOrg} 
								setError={setError}
							/>
						)}
					</Container>
				</div>
			)}
		</>
	);
};

export default Settings;